import { get, isDraft } from '../../utils/object-helpers';
import { createHash } from '../../utils/string-helpers';
import { getLocalStorage, setLocalStorage } from '../../utils/local-storage';

export default class {
    onCreate(input, out) {
        const rawText = get(input, 'title.textSpans.0.text', '') +
            get(input, 'announcement.textSpans', []).map(ts => ts.text);
        this.isDraft = isDraft(out);
        this.currentCommsVersion = createHash(rawText);
        this.lastSeenVersionKey = 'seller-comms-version';
        this.state = {
            open: false
        };
    }
    onMount() {
        if (!this.isDraft && this.currentCommsVersion !== (getLocalStorage(this.lastSeenVersionKey) || '0')) {
            this.state.open = true;
        }
    }
    closeDialog() {
        this.state.open = false;
        setLocalStorage(this.lastSeenVersionKey, this.currentCommsVersion.toString());
    }
}
